export default __webpack_public_path__ + "static/media/AGC_Question_Paper_Class_5.a8f3dc10.pdf";